import { createContext, useContext } from 'react';

interface UrlRecordContext {
  title?: string;
  synopsis?: string;
  primaryContent?: any;
}

const context = createContext<UrlRecordContext | null>({});

export const useUrlRecordContext = (): UrlRecordContext => useContext(context);

export default context;
